/**
 * Console log redaction for Report Issue diagnostics (T-002).
 */

const REDACTED = '[REDACTED]';

/** JWT-shaped: three base64url segments separated by dots, reasonably long overall. */
const JWT_LIKE_PATTERN = /[A-Za-z0-9_-]{8,}\.[A-Za-z0-9_-]{8,}\.[A-Za-z0-9_-]{8,}/g;

/** token= or refresh_token= query/form style values. */
const TOKEN_PARAM_PATTERN = /\b(?:token|refresh_token)=([^\s&"'`,;]+)/gi;

/** JSON-ish "token" fields (case-insensitive key). */
const JSON_TOKEN_FIELD_PATTERN = /("(?:token|refresh_token)"\s*:\s*")([^"\\]*(?:\\.[^"\\]*)*)(")/gi;

function redactTokenParams(line: string): string {
    return line.replace(TOKEN_PARAM_PATTERN, match => {
        const eqIndex = match.indexOf('=');
        return `${match.slice(0, eqIndex + 1)}${REDACTED}`;
    });
}

function redactJsonTokenFields(line: string): string {
    return line.replace(JSON_TOKEN_FIELD_PATTERN, `$1${REDACTED}$3`);
}

function redactJwtLikeStrings(line: string): string {
    return line.replace(JWT_LIKE_PATTERN, REDACTED);
}

/**
 * Redact obvious secrets (`token`, `refresh_token`, long JWT-like strings)
 * from a single console ring-buffer line before send / GitHub issue body.
 */
export function redactConsoleLogLine(line: string): string {
    if (line === '') {
        return line;
    }
    let out = line;
    out = redactTokenParams(out);
    out = redactJsonTokenFields(out);
    out = redactJwtLikeStrings(out);
    return out;
}

/** Apply {@link redactConsoleLogLine} to each line. */
export function redactConsoleLogs(lines: string[]): string[] {
    return lines.map(redactConsoleLogLine);
}
